import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./index.scss";
import { ArrowIcon } from "../../../assets/icons/ArrowIcon";
import services from "../../../assets/images/services.png";
import { ServiceIcon } from "../../../assets/icons/ServiceIcon";
import { ServicesGreenIcon } from "../../../assets/icons/ServicesGreenIcon";
import { useNavigate } from "react-router-dom";

const ServicesSection = () => {
  const navigate = useNavigate();
  return (
    <div className="services-section">
      <div>
        <Row className="gx-0 mx-0 px-0">
          {/* Sidebar title */}
          <Col
            xs={1}
            className=" d-flex align-items-start justify-content-start"
          >
            <div className="btn-service-section">
              {" "}
              <div
                className="rotate-text"
                onClick={() => {
                  navigate("/services");
                  window.scrollTo(0, 0);
                }}
              >
                Services
              </div>
            </div>
          </Col>

          {/* Main content */}
          <Col xs={11}>
            <Row className="main-content gx-0 mx-0 px-0 g-5">
              {/* Left list */}
              <Col md={4} className="left-part">
                <h2 className="title mt-5">Nos services</h2>
                <p className="description">
                  Notre expertise pluridisciplinaire nous permet d’intervenir
                  sur l’ensemble de vos projets stratégiques, de la conception à
                  la mise en œuvre.
                </p>
                <ul className="service-list">
                  <li
                    onClick={() => {
                      navigate("/consulting");
                      window.scrollTo(0, 0);
                    }}
                  >
                    <div className="text-list">
                      <span>01</span> <h3> Consulting Stratégique</h3>
                    </div>
                    <ArrowIcon link={"/consulting"} />
                  </li>
                  <li
                    onClick={() => {
                      navigate("/developpement");
                      window.scrollTo(0, 0);
                    }}
                  >
                    <div className="text-list">
                      <span>02</span> <h3> Développement web</h3>
                    </div>
                    <ArrowIcon link={"/developpement"} />
                  </li>
                  <li
                    onClick={() => {
                      navigate("/marketing");
                      window.scrollTo(0, 0);
                    }}
                  >
                    <div className="text-list">
                      <span>03</span> <h3> Marketing Digital</h3>
                    </div>
                    <ArrowIcon link={"/marketing"} />
                  </li>
                  <li
                    onClick={() => {
                      navigate("/design");
                      window.scrollTo(0, 0);
                    }}
                  >
                    <div className="text-list">
                      <span>04</span> <h3> Design Graphique </h3>
                    </div>
                    <ArrowIcon link={"/design"} />
                  </li>
                </ul>
              </Col>
              <Col xxl={1} className="d-lg-none d-xxl-block"></Col>
              {/* Center image */}
              <Col xxl={4} lg={5} className="image-part mt-md-5 mt-0">
                <img
                  src={services}
                  alt="Services"
                  className="img-fluid rounded mt-md-5 mt-0 mb-5"
                />
              </Col>

              {/* Right part */}
              <Col
                lg={3}
                xxl={2}
                className="right-part d-flex flex-column justify-content-between   mt-md-5 mt-0 mb-5"
              >
                <div className="gray-box   mt-md-5 mt-0 mb-5">
                  <p>
                    Notre expertise pluridisciplinaire nous permet d'intervenir
                    sur l'ensemble de vos projets stratégiques, de la conception
                    à la mise en œuvre.
                  </p>
                  <button
                    onClick={() => {
                      navigate(`/apropos`);
                      window.scrollTo(0, 0);
                    }}
                    className="see-more"
                  >
                    Voir Plus
                    <span>
                      <ServiceIcon />
                    </span>
                  </button>
                </div>
                <div className="green-box   mb-md-5 mb-0 ">
                  <p>
                    Faites confiance à Consultek pour transformer vos défis en
                    opportunités de croissance.
                  </p>
                  <button
                    onClick={() => {
                      navigate(`/contact#contact-section`);
                    }}
                    className="see-more"
                  >
                    Contactez-nous
                    <span>
                      <ServicesGreenIcon />
                    </span>
                  </button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ServicesSection;
